import { createState } from "@tecnobit-srl/state";
import { Component, Suspense, createContext, createElement, useCallback, useMemo } from "react";
import { merge } from "lodash-es";
import { GenericError } from "@tecnobit-srl/ui-generic-error";
import { jsx } from "react/jsx-runtime";
//#region ../../../../node_modules/react-error-boundary/dist/react-error-boundary.js
var f = createContext(null);
function m({ children: r, didCatch: e, error: t, resetErrorBoundary: o }) {
	const n = useMemo(() => ({
		didCatch: e,
		error: t,
		resetErrorBoundary: o
	}), [
		e,
		t,
		o
	]);
	return createElement(f.Provider, { value: n }, r);
}
var d = {
	didCatch: !1,
	error: null
};
var C = class extends Component {
	constructor(e) {
		super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = d;
	}
	static getDerivedStateFromError(e) {
		return {
			didCatch: !0,
			error: e
		};
	}
	resetErrorBoundary(...e) {
		const { didCatch: t } = this.state;
		t && (this.props.onReset?.({
			args: e,
			reason: "imperative-api"
		}), this.setState(d));
	}
	componentDidCatch(e, t) {
		this.props.onError?.(e, t);
	}
	componentDidUpdate(e, t) {
		const { didCatch: o } = this.state, { resetKeys: n } = this.props;
		o && t.didCatch && g(e.resetKeys, n) && (this.props.onReset?.({
			next: n,
			prev: e.resetKeys,
			reason: "keys"
		}), this.setState(d));
	}
	render() {
		const { children: e, fallbackRender: t, FallbackComponent: o, fallback: n } = this.props, { didCatch: s, error: a } = this.state;
		let c = e;
		if (s) {
			const u = {
				error: a,
				resetErrorBoundary: this.resetErrorBoundary
			};
			if (typeof t == "function") c = t(u);
			else if (o) c = createElement(o, u);
			else if ("fallback" in this.props) c = n;
			else throw a;
		}
		return createElement(m, {
			didCatch: s,
			error: a,
			resetErrorBoundary: this.resetErrorBoundary
		}, c);
	}
};
function g(r = [], e = []) {
	return r.length !== e.length || r.some((t, o) => !Object.is(t, e[o]));
}
//#endregion
//#region src/index.tsx
function SuspenseFallback(_props) {
	return null;
}
function createComponentStore(name) {
	const { ContextProvider: ComponentStoreProvider, useStore } = createState(name, (set) => ({
		components: {},
		addComponent: (id, component) => {
			set((state) => {
				return {
					...state,
					components: {
						...state.components,
						[id]: component
					}
				};
			});
		}
	}), (state, props) => ({
		...state,
		...props,
		components: props.components ? merge(state.components, props.components) : state.components
	}));
	const useAddComponent = () => {
		return useStore((state) => state.addComponent);
	};
	const useComponents = () => {
		return useStore((state) => state.components);
	};
	function Component({ id, p }) {
		const components = useComponents();
		const currentComponent = useMemo(() => components[id], [components, id]);
		const LazyComponent = useMemo(() => currentComponent?.component, [currentComponent]);
		const renderError = useCallback(({ error, resetErrorBoundary }) => {
			return /* @__PURE__ */ jsx(GenericError, {
				message: void 0,
				resetError: resetErrorBoundary
			});
		}, [id]);
		if (!currentComponent || !LazyComponent) return /* @__PURE__ */ jsx(GenericError, { message: void 0 });
		const content = /* @__PURE__ */ jsx(C, {
			fallbackRender: renderError,
			children: /* @__PURE__ */ jsx(LazyComponent, {
				ref: null,
				...p
			})
		});
		if (currentComponent.loadingComponent !== void 0) return /* @__PURE__ */ jsx(Suspense, {
			fallback: currentComponent.loadingComponent,
			children: content
		});
		return content;
	}
	return {
		ComponentStoreProvider,
		useAddComponent,
		useComponents,
		Component
	};
}
//#endregion
export { SuspenseFallback, createComponentStore };
